import { Absolute, Box, Flex } from '@cowsquare/design';
import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import PageNotFoundImage from '../../../asset/pageNotFound.svg';
import { isBrowser } from '../../../utils/isBrowser';

const CardBox = styled(Box).attrs({
  width: 1,
  height: ['150px', '285px'],
  p: '30px',
  my: ['100px', '150px'],
})`
  background-image: url(${PageNotFoundImage});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: relative;
`;

const Title = styled(Box)`
  font-family: OpenSans;
  font-size: ${themeGet('fontSizes.h1')};
  font-weight: ${themeGet('fontWeights.semibold')};
  line-height: normal;
  color: ${themeGet('colors.primaryDark')};
`;

const SubTitle = styled(Box)`
  font-family: OpenSans;
  font-size: ${themeGet('fontSizes.h4')};
  line-height: 1.5;
  color: ${themeGet('colors.primaryDark')};
`;

const StyledAbsolute = styled(Absolute).attrs({
  top: '50%',
  left: 0,
  right: 0,
})`
  transform: translateY(-50%);
`;

const PageNotFound = () => {
  if (!isBrowser) {
    return null;
  }

  return (
    <Flex alignItems="center" justifyContent="center">
      <CardBox>
        <StyledAbsolute>
          <Flex flexDirection="column" alignItems="center" justifyContent="center">
            <Title mb={10}>Page not found !</Title>
            <SubTitle>We can’t find the page that you’re looking for.</SubTitle>
          </Flex>
        </StyledAbsolute>
      </CardBox>
    </Flex>
  );
};

export default PageNotFound;
